import { watch } from 'vue';
import { useRouter, type RouteLocationRaw } from 'vue-router';

import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';

const useTradingMobileRoutes = (redirectRoute: RouteLocationRaw = { name: 'exchange' }) => {
  const router = useRouter();
  const { isXS } = useMQBreakpoints();

  watch(
    isXS,
    (v) => {
      if (!v) {
        router.push(redirectRoute);
      }
    },
    { immediate: true },
  );
};

export default useTradingMobileRoutes;
